import { AbsoluteModelPath, IModelPath } from "../ModelPath";
import { EachCurrentCollision } from "../EachCurrentCollision";

import { Set2 } from "./Set2";

export class AbsoluteModelPathSet extends Set2<AbsoluteModelPath> {
    private readonly eachCurrentCollision: EachCurrentCollision;

    public constructor(eachCurrentCollision: EachCurrentCollision = EachCurrentCollision.AreSame) {
        super();
        this.eachCurrentCollision = eachCurrentCollision;
    }

    public static *unique<R extends boolean>(paths: Iterable<IModelPath<R, true>>): Iterable<IModelPath<R, true>> {
        const set = new AbsoluteModelPathSet();
        for (const path of paths) {
            if (set.add(path)) {
                yield path;
            }
        }
    }

    protected areItemsEqual(left: AbsoluteModelPath, right: AbsoluteModelPath): boolean {
        return left.isEquals(right, this.eachCurrentCollision);
    }

    protected getItemHash(key: AbsoluteModelPath): number {
        return key.getHash(this.eachCurrentCollision);
    }

    public static from(source: Iterable<AbsoluteModelPath>): AbsoluteModelPathSet {
        const set = new AbsoluteModelPathSet();
        for (const sourceElement of source) {
            set.add(sourceElement);
        }
        return set;
    }
}
